/**
 * Composant Header responsive - Affiche le nom de l'association et des infos contextuelles
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <header className="lg:hidden bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm">
      <div className="px-4 sm:px-6">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo et nom de l'association */}
          <div className="flex items-center gap-3 pl-12">
            <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-lg border border-gray-200 shadow-sm p-1.5">
              <img
                src="/images/logo_transparent.png"
                alt="Logo Crions D'Couleurs"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <h1 className="text-base sm:text-lg font-bold text-gray-900 leading-tight">
                Crions D'Couleurs
              </h1>
              <p className="text-xs text-gray-500 hidden sm:block">
                Gestion des séjours
              </p>
            </div>
          </div>

          {/* Informations utilisateur mobile - clicable pour aller au profil */}
          <button
            onClick={() => navigate('/profil')}
            className="flex items-center hover:opacity-80 transition-opacity"
            aria-label="Aller au profil"
          >
            <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
              <span className="text-primary-600 font-semibold text-sm">
                {user?.first_name?.[0]}{user?.last_name?.[0]}
              </span>
            </div>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
